<script setup lang="ts">
import Toggle from '@components/Toggle.vue';
import Typography from '@components/Typography.vue';
import { useFilterStore } from '@stores/useFilterStore.ts';
import { storeToRefs } from 'pinia';
import { trans } from '@tools/translation.ts';

const filterStore = useFilterStore();
const { enableAggregate } = storeToRefs(filterStore);
const { toggleEnableAggregate } = filterStore;
</script>

<template>
  <div
    :class="[
      'flex cursor-pointer items-center gap-2 p-4',
      'border-0 border-t border-solid border-gray'
    ]"
  >
    <Toggle
      class="mt-1 self-start"
      :value="enableAggregate"
      @onchange="toggleEnableAggregate"
    />

    <div
      class="flex w-[396px] flex-col"
      @click="toggleEnableAggregate"
    >
      <Typography variant="body-small">
        {{ trans('search.filter.no_aggregate.label') }}
      </Typography>

      <Typography variant="caption" color="gray-dark" class="text-wrap">
        {{ trans('search.filter.no_aggregate.notice') }}
      </Typography>
    </div>
  </div>
</template>
